<template>
	<svg class="e-icon" :data-name="name" :class="feature">
		<use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'/assets/img/svg/icons.svg#' + name"></use>
	</svg>
</template>

<script>


export default {
	name: "c-icon",
	props: ["name", "feature"],
	data (){
		return {
		}
	},
	computed: {
	}
}
	
</script>


// WEBPACK FOOTER //
// icon.vue?41b2bc1a